<template>
	<div class="in-conclusion">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>The Web Audio Explanation I Wish I Had</h2>
		<div v-if="part === 1">
			<div class="confetti">
			<div class="excited-top">Conclusion</div>
			<div class="excited bottom">🎉 Web audio is here! <span class="asterisk">✽</span></div>
			</div>
			<p><span class="asterisk">✽</span> Some restrictions apply (see previous slides).</p>
		</div>
		<div v-if="part === 2">
			<h3>Stay In Touch!</h3>
			<img src="@/assets/images/telephone.png" alt="telephone"/>
			<p><a class="contact" href="https://paulrosen.net/contact-me/">https://paulrosen.net/contact-me/</a></p>
		</div>
		<div class="hammer-flex" v-if="part === 3">
			<div>
			<img src="@/assets/images/help.png" alt="hammer"/>
			</div>
			<div class="right-half">
			<h3>Help out!</h3>
			<p>If you have the hankering, there are lots of unfinished parts in abcjs:</p>
				<p>New features, better layout, optimization, new examples, documentation, testing, test framework, build tools...</p>
			</div>
		</div>
		<div v-if="part === 4">
			<h3>Questions?</h3>
			<img src="@/assets/images/questions.png" alt="students with hands raised"/>
		</div>
	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "in-conclusion",
		components: {SpeakerNotes},
		mixins: [
			PageParts,
		],
		data() {
			return {
				notes: [
					[
						"Except for IE11, nearly all browsers and devices support it.",
						"Some older phones are just too slow.",
					],
					[
						"Contact me if you have questions or comments.",
						"I'm still a student of this stuff and I'd like to know more.",
					],
					[
						"I'd welcome some help with abcjs.",
						"However you'd like.",
					],
					[
						"Thanks so much for listening.",
						"And thanks to RVA JS for giving me the opportunity.",
					],
				],
			};
		},
	};
</script>

<style lang="scss" scoped>
	.in-conclusion {
		text-align: center;
	}
	.confetti h3 {
		background: white;
		display: inline;
		padding: 0 10px 10px 10px;
		border-radius: 12px;
	}
	.confetti {
		width: 80%;
		height: 800px;
		background-image: url("../assets/images/party.png");
		background-size: cover;
		margin: 0 auto;
	}
	.asterisk {
		color: $not-color;
		vertical-align: super;
	}
	h3 {
		font-size: 2em;
	}
	.excited-top {
		background: white;
		display: inline;
		padding: 0 20px;
		border-radius: 20px;
		color: #5a78f1;
		font-weight: bold;
		font-size: 2.5em;
	}
	.excited {
		color: #5a78f1;
		font-weight: bold;
		font-size: 2.5em;
		text-shadow: 10px 10px 10px $excited-background, -10px -10px 10px $excited-background, 10px -10px 10px $excited-background, -10px 10px 10px $excited-background;
	}
	.bottom {
		position: absolute;
		bottom: 170px;
		width: 100%;
		text-align: center;
		left: 0;
	}
	.contact {
		color: #000000;
		text-underline-offset: 5px;
		text-decoration-thickness: 6px;
		text-decoration-color: cyan;

		&:hover {
			text-decoration: underline;
		}
	}
	@media screen and (min-width: 490px) {
		.contact {
			font-size: 2em;
		}
		.hammer-flex {
			display: flex;
			margin: 20px;
			justify-content: center;
		}
		.right-half {
			max-width: 40%;
			padding-left: 40px;
		}
	}
	.right-half {
		text-align: left;
	}
</style>
